<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="名称"
                    prop="consumerName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.consumerName"
                      disabled
                    >
                      <el-button
                        v-if="eventType==='add'"
                        slot="append"
                        icon="el-icon-search"
                        @click="dialogConsumerVisible=true"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="地址">
                    <el-input
                      v-model="dialogAddEditViewForm.address"
                      disabled
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="电话">
                    <el-input
                      v-model="dialogAddEditViewForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item
                    label="奖品名称"
                    prop="settingName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.settingName"
                      disabled
                    >
                      <el-button
                        v-if="eventType==='add'"
                        slot="append"
                        icon="el-icon-search"
                        @click="dialogSettingVisible=true"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="活动类型"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.settingSortStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="兑换中奖时间"
                    prop="exchangeTime"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.exchangeTime"
                      :disabled="eventType !== 'add'"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="奖品数量"
                    prop="amount"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.amount"
                      style="width: 100%;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="门店名称"
                    prop="storeName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditViewForm.settingSort === 1"
                  :span="6"
                >
                  <el-form-item label="兑换积分">
                    <el-input
                      v-model="dialogAddEditViewForm.integral"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="eventType !== 'add'"
                :gutter="10"
              >
                <el-col :span="6">
                  <el-form-item
                    label="邮寄日期"
                    prop="expressDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.expressDate"
                      :disabled="eventType==='view'"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="快递公司"
                    prop="expressName"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.expressName"
                      filterable
                      clearable
                      placeholder="请选择快递公司"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in expressOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.expressName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="快递单号"
                    prop="expressNo"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.expressNo"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="寄件人"
                    prop="expressUserName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.expressUserName"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="邮寄费用"
                    prop="expressFee"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.expressFee"
                      :disabled="eventType==='view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'expressFee')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'expressFee',2)"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType==='view'"
                  :span="6"
                >
                  <el-form-item label="物流状态">
                    <el-input
                      v-model="dialogAddEditViewForm.expressStatusStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType==='view'"
                  :span="6"
                >
                  <el-form-item label="是否签收">
                    <el-input
                      v-model="dialogAddEditViewForm.isSignStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType==='view'"
                  :span="24"
                >
                  <el-form-item label="最新物流信息">
                    <el-input
                      v-model="dialogAddEditViewForm.lastExpressStatus"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType==='view'"
                  :span="24"
                >
                  <el-form-item label="全部物流信息">
                    <el-timeline :reverse="false">
                      <el-timeline-item
                        v-for="(activity, index) in activities"
                        :key="index"
                        :timestamp="activity.time"
                      >
                        {{ activity.status }}
                      </el-timeline-item>
                    </el-timeline>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType==='view' && Number(getUserId()) === 1"
                  :span="24"
                >
                  <el-form-item label="物流信息JSON">
                    <el-input
                      v-model="dialogAddEditViewForm.expressResult"
                      type="textarea"
                      autosize
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="eventType === 'edit'"
            class="modal-box pic-container"
          >
            <h3 class="modal-title">
              照片信息<span style="padding-left:30px;color:red">上传图片大小：小于10M; 格式：png、jpg、jpeg、gif; 图片尺寸建议：750x420</span>
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  class="upload-button"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div
            v-if="eventType === 'view'"
            class="modal-box pic-container"
          >
            <h3 class="modal-title">
              照片信息
            </h3>
            <div class="modal-row-box">
              <div class="demo-input-suffix">
                <show-preview :arr-file-data="picList" />
              </div>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
      <!--图片预览-->
      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>
    <setting-list-dialog
      :dialog-visible.sync="dialogSettingVisible"
      dialog-title="积分兑换奖品信息"
      @selectedSettingFun="selectedSettingFun"
    />
    <consumer-list-dialog
      :dialog-visible.sync="dialogConsumerVisible"
      dialog-title="积分兑换消费者信息"
      @selectedConsumerFun="selectedConsumerFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 图片预览
import showPreview from '@/components/showPreview'
import consumerListDialog from './consumerListDialog'
import settingListDialog from './settingListDialog'
import { getUserId, getToken } from "@/utils/auth"
import { findAttachmentInfoByConditionApi, deleteFileApi } from '@/api/common'
import { initAppConsumerIntegralExchangeRewardApi, saveOrUpdateAppConsumerIntegralExchangeRewardApi } from '@/api/appConsumerIntegralExchangeReward'
export default {
  components: { showPreview, consumerListDialog, settingListDialog },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        consumerName: [{ required: true, message: '请选择兑换消费者', trigger: 'blur' }],
        settingName: [{ required: true, message: '请选择兑换奖品', trigger: 'blur' }],
        exchangeTime: [{ required: true, message: '请选择兑换时间', trigger: 'change' }],
        expressDate: [{ required: true, message: '请选择邮寄日期', trigger: 'change' }],
        expressName: [{ required: true, message: '请选择快递公司', trigger: 'change' }],
        expressNo: [{ required: true, message: '请输入快递单号', trigger: 'blur' }, { max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        expressUserName: [{ required: true, message: '请输入寄件人', trigger: 'blur' }, { max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      expressOptions: [{ label: '顺丰快递' }, { label: '申通快递' }, { label: '中通快递' }, { label: '圆通快递' }, { label: '韵达快递' }, { label: '邮政快递' }, { label: '京东快递' }, { label: '极兔快递' }],
      activities: [],
      dialogConsumerVisible: false,
      dialogSettingVisible: false,
      //上传相关
      picData: { directory: 'appConsumerIntegralExchangeReward' },
      picUploadAction: '',
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.activities = []
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadExpressFile'
        this.picList = []
        this.initFileList = []
        this.dialogAddEditViewForm = {
          provinceName: '',
          consumerName: '',
          phone: '',
          address: '',
          settingName: '',
          settingSort: 0,
          settingSortStr: '',
          exchangeTime: '',
          exchangeTimeStr: '',
          storeName: '',
          amount: '',
          integral: '',
          expressDate: '',
          expressName: '',
          expressNo: '',
          expressUserName: '',
          expressFee: '',
          expressStatusStr: '',
          isSignStr: '',
          lastExpressStatus: '',
          expressResult: '',
          remark: ''
        }
        if (this.eventType !== 'add') {
          this.initConsumerIntegralExchangeRewardData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    getUserId,
    getToken,
    // 加载数据
    initConsumerIntegralExchangeRewardData() {
      initAppConsumerIntegralExchangeRewardApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          if (key !== 'expressDate' && key !== 'exchangeTime') {
            this.dialogAddEditViewForm[key] = data[key]
          }
        }
        this.dialogAddEditViewForm.exchangeTime = data.exchangeTimeStr
        this.dialogAddEditViewForm.expressDate = data.expressDateStr
        this.dialogAddEditViewForm.id = data.id
        if (data.expressResult) {
          this.activities = JSON.parse(data.expressResult).list
        }
        findAttachmentInfoByConditionApi({ sourceType: 34, sourceId: data.id }).then(res1 => {
          if (res1.data && res1.data.length > 0) {
            res1.data.forEach(item => {
              let obj = {}
              obj.name = item.attachmentName
              obj.url = this.baseUrl + item.attachmentUrl
              obj.attachmentName = item.attachmentName
              obj.attachmentUrl = item.attachmentUrl
              this.picList.push(obj)
              this.initFileList.push(obj)
            })
          }
        })
        this.loading = false
      })
    },
    // 图片上传前
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过10MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess(res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        if (res.codeText) {
          this.dialogAddEditViewForm.expressNo = res.codeText
          if (res.codeText.indexOf('SF') !== -1) {
            this.dialogAddEditViewForm.expressName = '顺丰快递'
          }
        }
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove(file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 选择消费者
    selectedConsumerFun(val) {
      this.dialogAddEditViewForm.consumerId = val.id
      this.dialogAddEditViewForm.consumerName = val.name
      this.dialogAddEditViewForm.provinceName = val.provinceName
      this.dialogAddEditViewForm.phone = val.phone
      this.dialogAddEditViewForm.address = val.address
    },
    // 选择奖品
    selectedSettingFun(val) {
      this.dialogAddEditViewForm.settingId = val.id
      this.dialogAddEditViewForm.settingName = val.name
      this.dialogAddEditViewForm.integral = val.integral
      this.dialogAddEditViewForm.settingSort = val.sort
      this.dialogAddEditViewForm.settingSortStr = val.sortStr
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定录入邮寄信息', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              let picUrls = []
              let picNames = []
              this.picList.forEach(item => {
                picUrls.push(item.attachmentUrl)
                picNames.push(item.attachmentName)
              })
              this.dialogAddEditViewForm.picUrls = JSON.stringify(picUrls)
              this.dialogAddEditViewForm.picNames = JSON.stringify(picNames)
              if (this.eventType === 'add') {
                this.dialogAddEditViewForm.isHandAdd = '1'
              } else {
                this.dialogAddEditViewForm.isExpress = 1
              }
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave() {
      saveOrUpdateAppConsumerIntegralExchangeRewardApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
</style>
